/**
 * HubSpot Sales
 *
 * Exposes ~90 files to every origin with no `use_dynamic_url`, including the vendor
 * `img/hubspot-logo-*.png` icons and `pages/sidepanel.html`. All are fetchable from any
 * page at a fixed URL.
 *
 * Manifest verified against version 3.1.1.42592.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'oiiaigjnkhngdbnoookogelabohpglmd';

export const hubspotSales: ExtensionDefinition = {
  id: ID,
  name: 'HubSpot Sales',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes: '~90 static WAR on all origins; branded HubSpot icons make it conclusive.',
  signals: [
    {
      id: 'war-hubspot-logo',
      kind: 'web-accessible-resource',
      description:
        'Load img/hubspot-logo-32.png via <img> — a vendor-named icon exposed to every ' +
        'origin, readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'img/hubspot-logo-32.png'),
    },
    {
      id: 'war-sidepanel-html',
      kind: 'web-accessible-resource',
      description: 'Fetch pages/sidepanel.html — corroborates independently of the icon.',
      weight: 0.5,
      run: () => probeFetch(ID, 'pages/sidepanel.html'),
    },
  ],
};
